import Tcb from '@/tcb'
const EngineeringTab = {
  data: () => ({
    engineeringItems: [{
      id: 0,
      title: '物资招标',
      status: '4',
      supEnterpriseIds: 37490,
      bidType: 'purchase'
    }, {
      id: 1,
      title: '工程招标',
      status: '11,23',
      supEnterpriseIds: 37490,
      bidType: 'logistics'
    }, {
      id: 2,
      title: '服务招标',
      status: '12,24',
      supEnterpriseIds: 37490,
      bidType: 'logistics'
    }, {
      id: 3,
      title: '物流招标',
      status: '6',
      supEnterpriseIds: 37490,
      bidType: 'logistics'
    }]
  }),
  methods: {
    // onChange (e, that) {
    //   console.log(e)
    //   console.log(that.$refs.tabItem)
    // }
  }
}
const LogisticsTab = {
  data: () => ({
    logisticsItems: [{
      id: 0,
      title: '澄清公告',
      status: 19,
      supEnterpriseIds: 37490,
      bidType: 'purchase'
    }, {
      id: 1,
      title: '中标候选人公告',
      status: 5,
      supEnterpriseIds: 37490,
      bidType: 'allBidNotice'
    }, {
      id: 2,
      title: '中标结果公告',
      tenantid: 'paikhs6q'
    }, {
      id: 3,
      title: '流标公告',
      status: 18,
      supEnterpriseIds: 37490,
      bidType: 'purchase'
    }]
  }),
  methods: {
    // onChange (e, that) {
    //   console.log(e)
    //   console.log(that.$refs.tabItem)
    // }
  }
}
const NewEngineeringTab = {
  data: () => ({
    engineeringItems: [{
      id: 0,
      // title: '招标公告',
      // status: '4,6,11,12,15',
      // supEnterpriseIds: 25210,
      // bidType: 'zhaobiaoNotice'
      title: '企业公告',
      tenantid: 'paikhs6q'
    }, {
      id: 1,
      title: '询价公告',
      status: '0',
      supEnterpriseIds: 25210,
      bidType: 'xunyuanNotice'
    }, {
      id: 2,
      title: '标书公告',
      status: '21,22,23,24',
      supEnterpriseIds: 25210,
      bidType: 'biaoshuNotice'
    }, {
      id: 3,
      title: '其他',
      status: '1,11,13,12,24',
      supEnterpriseIds: 25210,
      bidType: 'purchase'
    }]
  }),
  methods: {
    // onChange (e, that) {
    //   console.log(e)
    //   console.log(that.$refs.tabItem)
    // }
  }
}
const NewLogisticsTab = {
  data: () => ({
    logisticsItems: [{
      id: 0,
      title: '澄清公告',
      status: '19,25',
      supEnterpriseIds: 25210,
      bidType: 'purchase'
    }, {
      id: 1,
      title: '中标候选人公告',
      status: '8,31,32,33',
      supEnterpriseIds: 25210,
      bidType: 'houxuanNotice'
    }, {
      id: 2,
      title: '中标结果公告',
      status: '5,7,13,14',
      supEnterpriseIds: 25210,
      bidType: 'zhongbiaoNotice'
    }, {
      id: 3,
      title: '流标公告',
      status: 18,
      supEnterpriseIds: 25210,
      bidType: 'purchase'
    }
    // , {
    //   id: 4,
    //   title: '企业公告',
    //   tenantid: 'paikhs6q'
    // }
    ]
  }),
  methods: {
    // onChange (e, that) {
    //   console.log(e)
    //   console.log(that.$refs.tabItem)
    // }
  }
}
const News = {
  data: () => ({
    news: [],
    total: 0,
    skip: 0,
    paginationLength: 0,
    pagination: false
  }),
  methods: {
    async input (page) {
      this.skip = page - 1
      await this.getNews()
    },
    async getNews () {
      const limit = 10
      const db = Tcb.database()
      try {
        const query = db.collection('article').orderBy('_createTime', 'desc').orderBy('order', 'desc').skip(this.skip * limit).limit(limit)
        const reqArr = [query.get()]
        if (!this.total) {
          reqArr.push(query.count())
        }
        const res = await Promise.all(reqArr)
        // console.log('news', res)
        if (res[1]) {
          this.total = res[1].total
          if (this.total > this.limit) {
            this.pagination = true
            this.paginationLength = this.total
          }
        }
        if (res[0].data.length > 0) {
          this.$set(this.news, this.skip, res[0].data.map(item => {
            const { _id, date, title } = item
            return {
              id: _id,
              date: new Date(date),
              title
            }
          }))
          console.log(this.news)
        }
      } catch (error) {
        // console.log(error)
      }
    },
    newsItemOnClick (item) {
      console.log(item)
      this.$router.push({
        path: `news/${item.id}`
      })
    }
  }
}
const LatestNews = {
  data: () => ({
    latestNews: []
  }),
  methods: {
    async getLatestNews () {
      const limit = 10
      const db = Tcb.database()
      try {
        const query = db.collection('article').orderBy('_createTime', 'desc').limit(limit)
        const res = await query.get()
        // console.log('latestNews', res)
        if (res.data.length > 0) {
          this.latestNews = res.data.map(item => {
            const { _id, date, title, cover } = item
            return {
              id: _id,
              date: new Date(date),
              imgSrc: cover[0],
              title
            }
          })
        }
      } catch (error) {
        // console.log(error)
      }
    },
    newsItemOnClick (item) {
      console.log(item)
      this.$router.push({
        path: `news/${item.id}`
      })
    }
  }
}
export {
  EngineeringTab,
  LogisticsTab,
  News,
  LatestNews,
  NewEngineeringTab,
  NewLogisticsTab
}
